function validateError() {
    var error = 0;
    $('[data-validation]').each(function () {
        if (!$(this).hasClass('d-none')) {
            error++;
        }
    });

    if (error > 0) {
        return true;
    }

    return false;
}

$(document).on('change', '[data-validation-food-name]', function () {
    checkValidationFoodName();
});

function checkValidationFoodName() {
    $.ajax({
        url: Routing.generate('validation_food_name', {
            'name': $('#food-name').val(),
            'restaurant': $('#food-restaurant-id').val(),
            'date': $('#food-date').val(),
            'id': $('#food-id').val(),
        })
    }).done(function (res) {
        var error = $('[data-validation-food-name-error]');
        if (!res.state) {
            error.removeClass('d-none');
        } else {
            error.addClass('d-none');
        }
    });
}

$(document).on('change', '[data-validation-restaurant-vendor-code]', function () {
    checkValidationRestaurantVendorCode();
});

function checkValidationRestaurantVendorCode() {
    $.ajax({
        url: Routing.generate('validation_restaurant_vendor_code', {
            'vendorCode': $('#restaurant-vendor-code').val(),
            'id': $('#restaurant-id').val(),
        })
    }).done(function (res) {
        var error = $('[data-validation-restaurant-vendor-code-error]');
        if (!res.state) {
            error.removeClass('d-none');
        } else {
            error.addClass('d-none');
        }
    });
}

jQuery.validator.addMethod("alphanumeric", function (value, element) {
    return this.optional(element) || /^[\w]+$/i.test(value);
}, "Pouze alfanumerické znaky");